/// <reference path='../../docs-and-forms.module.ts' />
/// <reference path='../../../../../../typings/index.d.ts' />
/// <reference path='../../docs-and-forms.models.ts' />

module Meevo.Plugins.DocsAndForms {

    interface IDocsAndFormsFormBuilderComponentScope extends ng.IScope {

    }

    class DocsAndFormsFormBuilderComponent implements ng.IComponentController {

        static $inject = [
            '$scope',
            'meevo.plugins.docsAndForms.DocsAndFormsRenderService',
        ];

        public code: string;
        public formType: string;

        public formBuilderModel: IFormBuilderModel;
        public docsAndFormsModel: IDocsAndFormsModel;
        public disabled: boolean;

        constructor(private $scope: IDocsAndFormsFormBuilderComponentScope,
                    private docsAndFormsRenderService: DocsAndFormsRenderService) {
            this.code = '';
        }

        $onInit() {
            this.$scope.$watch(() => [
                ...this.formBuilderModel.selectedSystemTagsNames,
                ...this.formBuilderModel.selectedUDFs
            ], () => {
                this.docsAndFormsRenderService
                    .generateHTMLExamplesTemplate(this.$scope, this.formBuilderModel)
                    .then((html: string) => {
                        this.code = html;

                        if (this.docsAndFormsModel) {
                            this.docsAndFormsModel.builderHTML = html;
                        }
                    });
            }, true);
        }
    }

    angular.module('meevo.plugins.docsAndForms')
        .component('docsAndFormsFormBuilderComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/docsAndForms/components/form-builder/docs-and-forms-form-builder.component.html',
            controller: DocsAndFormsFormBuilderComponent,
            controllerAs: '$ctrl',
            bindings: {
                docsAndFormsModel: '=',
                formBuilderModel: '=',
                disabled: '=?ngDisabled',
                formType: '@'
            }
        });

}
